import 'prop-types';
import * as React from 'react';

var useIsMounted = function useIsMounted() {
  var isMounted = React.useRef(false);
  React.useEffect(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);
  return isMounted;
};

export { useIsMounted };
